<template>
  <div class="home--wrapper">
    <div class="new--wrapper">
      <img
        class="new_bg--img"
        src="https://src.leju.com/imp/imp/deal/94/da/7/9e156713d018d9b45d284b736b1_p122_mk169.png"
      />
      <img
        class="logo_bg--img"
        src="https://src.leju.com/imp/imp/deal/d1/21/0/aa7498cdc498a3c6c086a8fcade_p122_mk169.png"
      />
      <div :class="`logo ${SHOW_TAO ? 'sprite-logo' : 'sprite-logo1'}`"></div>
      <div
        class="cur-city--wrapper sprite-cur-city-border"
        @click="handleSelectCity"
      >
        <div class="cur-city--icon sprite-location"></div>
        <div class="cur-city--text">{{
          mainData && mainData.city_map ? mainData.city_map : '定位中'
        }}</div>
      </div>
      <Image
        v-if="SHOW_TAO && mainData.tianmao_taoling"
        @click="copyTaoling(mainData.tianmao_taoling)"
        width="98"
        height="98"
        class="tianmao"
        src="https://src.leju.com/imp/imp/deal/98/63/8/1991c14ddbcbfc1cf40d9d75a0c_p122_mk169.png"
      />
      <div class="new--tabs">
        <div class="new--tab sprite-new3"></div>
        <div
          class="new--tab sprite-hot3"
          @click="jump({ type: 'tab', data: 'hot' })"
        ></div>
        <div
          class="new--tab sprite-home3"
          @click="jump({ type: 'tab', data: 'home' })"
        ></div>
      </div>
    </div>
    <div
      v-if="SHOW_TAO && ACTIVITY_ENTRY"
      @click="copyTaoling(ACTIVITY_ENTRY)"
      class="activity_entry--wrapper"
    >
      <Image
        width="100%"
        height="100%"
        src="https://src.leju.com/imp/imp/deal/21/eb/1/8ba48e8c8fcef6ae8da72763844_p122_mk169.png"
      />
    </div>
    <Image
      class="cloud-bg"
      src="https://src.leju.com/imp/imp/deal/f8/20/5/e3dd2913ce6fa15fda39ec3a54a_p122_mk169.png"
    />
    <div class="live--wrapper" v-if="liveData.length" :key="city">
      <Image
        class="u-title-img"
        src="https://src.leju.com/imp/imp/deal/ea/a1/2/6db10e97f3b775a617b62f1c522_p122_mk169.png"
      />
      <div class="live--content">
        <Carousel
          class="live--carousel"
          :data="liveData"
          keyMap="id"
          :options="{
            loop: true,
            // lazy: true,
            loadPrevNext: true,
            loadPrevNextAmount: 2,
            on: {
              tap({ realIndex }) {
                jump({ type: 'link', data: liveData[realIndex].url })
              }
            }
          }"
        >
          <template v-slot="{ item }">
            <div class="live_item">
              <img
                :src="
                  item.house_cover ||
                  'https://src.leju.com/imp/imp/deal/02/50/7/77710ffd520bbd3dad51dafe886_p122_mk169.jpg'
                "
                class="swiper-lazy live--cover"
              />
              <div class="sprite-super-red"></div>
              <div class="sprite-live"></div>
              <div :class="`live--status live--status__${item.status}`">
                <div
                  v-if="item.status == 1"
                  class="sprite-living live--icon"
                ></div>
                <div
                  v-else-if="item.status == 2"
                  class="sprite-foreshow live--icon"
                ></div>
                <div
                  v-else-if="item.status == 3"
                  class="sprite-replay live--icon"
                ></div>
                {{ ['', '直播中', '预告', '回放'][item.status] }}
              </div>
              <div class="live--tips item--tips">{{ item.title }}</div>
            </div>
          </template>
        </Carousel>
      </div>
    </div>
    <div
      class="new_year_quotation--wrapper"
      v-if="mainData.new_year_quotation && mainData.new_year_quotation.length"
    >
      <Image
        class="u-title-img"
        lazy-load
        src="https://src.leju.com/imp/imp/deal/fe/c1/8/2d202861c08389bc79876afb026_p122_mk169.png"
      />
      <div class="new_year_quotation--content" :key="city">
        <div
          v-for="(item, i) in mainData.new_year_quotation"
          :key="item.hid"
          :class="`new_year_quotation--item ${
            i === 0 && mainData.new_year_quotation.length % 2
              ? 'house_info_item__fill'
              : 'house_info_item__flex'
          }`"
          v-lazy:background-image="
            i === 0 && mainData.new_year_quotation.length % 2
              ? 'https://src.leju.com/imp/imp/deal/08/b8/4/718321f68ca589ea2546f1b78d5_p122_mk169.png'
              : 'https://src.leju.com/imp/imp/deal/e8/a7/0/b7693118d4b2841b6cbcc4ef51a_p122_mk169.png'
          "
          @click="jump({ type: 'house', data: item })"
        >
          <div class="new_year_quotation--img house_info_item--img">
            <img
              v-lazy="
                item.cover ||
                'https://src.leju.com/imp/imp/deal/02/50/7/77710ffd520bbd3dad51dafe886_p122_mk169.jpg'
              "
              class="house_info_item--image"
            />
            <div class="house_info_item--number" v-if="item.licence">{{
              item.licence
            }}</div>
            <div
              class="house_info_item--new_year sprite-new-year-straight"
            ></div>
          </div>
          <div class="new_year_quotation--niu sprite-new-icon"></div>
          <div class="new_year_quotation--info house_info_item--info">
            <div class="house_info_item--city" v-if="item.unified_city_cn"
              >{{ item.unified_city_cn
              }}{{
                item.unified_district ? `/${item.unified_district}` : ''
              }}</div
            >
            <div class="house_info_item--name">{{ item.name }}</div>
            <div class="house_info_item--tags" v-if="item.tags_name.length">
              <div
                class="house_info_item--tag"
                v-for="t in item.tags_name"
                :key="t"
              >
                {{ t }}
              </div>
            </div>
            <div class="house_info_item--price">{{
              item.price_display_info && item.price_display_info.price_display
                ? item.price_display_info.price_display
                : ' '
            }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="send_bless--wrapper"
      v-if="mainData.new_year_blessing && mainData.new_year_blessing.length"
    >
      <Image
        class="u-title-img"
        lazy-load
        src="https://src.leju.com/imp/imp/deal/25/9e/3/faa815b3e17cd37d1520b58e398_p122_mk169.png"
      />
      <div class="u-sub_title-img">
        <div class="sprite-diamond"></div>
        <div class="sub_title">品牌房企联欢送祝福</div>
        <div class="sprite-diamond"></div>
      </div>
      <div class="send_bless--carousel_wrapper" :key="city">
        <Carousel
          class="send_bless--carousel"
          :data="mainData.new_year_blessing"
          keyMap="video"
          :options="{
            on: {
              slideChangeTransitionEnd({ realIndex }) {
                if (playerRefs[realIndex]) {
                  const player = playerRefs[realIndex].getPlayer()
                  if (player) {
                    player.pause()
                  }
                }
              }
            }
          }"
        >
          <template v-slot="{ item }">
            <div class="video--wrapper">
              <Video
                :ref="ref => playerRefs.push(ref)"
                :on="{
                  playing: () => hideVideoTips(item)
                }"
                :options="{
                  poster:
                    item.cover ||
                    'https://src.leju.com/imp/imp/deal/f0/ab/2/59062805d521eeebd801237dbfd_p122_mk169.png',
                  url: item.video
                }"
              />
              <transition name="van-slide-up">
                <div class="item--tips video--tips" v-if="item.desc">{{
                  item.desc
                }}</div>
              </transition>
            </div>
          </template>
        </Carousel>
        <img
          class="send_bless--border"
          src="https://src.leju.com/imp/imp/deal/f4/ad/8/cfb1f78131e4a335132c2b40796_p122_mk169.png"
        />
      </div>
    </div>
    <div
      class="early_see--wrapper"
      v-if="mainData.new_year_auction && mainData.new_year_auction.video"
    >
      <Image
        class="u-title-img"
        lazy-load
        src="https://src.leju.com/imp/imp/deal/da/4e/8/51dffebb4aba7643b4db698e270_p122_mk169.png"
      />
      <div class="u-sub_title-img">
        <div class="sprite-diamond"></div>
        <div class="sub_title">新春置业好盘抢先看</div>
        <div class="sprite-diamond"></div>
      </div>
      <div class="video--wrapper" :key="city">
        <Video
          :on="{
            playing: () => hideVideoTips(mainData.new_year_auction)
          }"
          :options="{
            poster:
              mainData.new_year_auction.cover ||
              'https://src.leju.com/imp/imp/deal/f0/ab/2/59062805d521eeebd801237dbfd_p122_mk169.png',
            url: mainData.new_year_auction.video
          }"
        />
        <transition name="van-slide-up">
          <div
            class="item--tips video--tips"
            v-if="mainData.new_year_auction.desc"
            >{{ mainData.new_year_auction.desc }}</div
          >
        </transition>
      </div>
    </div>
    <Carousel
      v-if="mainData.ad_banner && mainData.ad_banner.length"
      class="ad_placeholder--list"
      :data="mainData.ad_banner"
      :options="{
        loop: true,
        on: {
          tap({ realIndex }) {
            jump({ type: 'link', data: mainData.ad_banner[realIndex].url })
          }
        }
      }"
    >
      <template v-slot="{ item }">
        <img class="ad_placeholder--item" :src="item.cover" />
      </template>
    </Carousel>

    <div
      class="big_show--wrapper"
      v-if="mainData.new_year_brand && mainData.new_year_brand.length"
    >
      <Image
        class="u-title-img"
        lazy-load
        src="https://src.leju.com/imp/imp/deal/1f/ab/b/e9aeee79a070e5caa79310c6442_p122_mk169.png"
      />
      <div class="big_show--list" :key="city">
        <div
          class="big_show--item"
          v-for="item in mainData.new_year_brand"
          :key="item.brand_id"
          v-lazy:background-image="
            'https://src.leju.com/imp/imp/deal/65/84/5/755ca215fc1a8f8c1ebc52ca0c6_p122_mk169.png'
          "
        >
          <div
            class="big_show--title-wrapper"
            @click="
              SHOW_TAO && item.taopass
                ? jump({ type: 'link', data: item.taopass })
                : () => {}
            "
            v-lazy:background-image="
              SHOW_TAO && item.taopass
                ? 'https://src.leju.com/imp/imp/deal/e6/86/e/155cd5dfe40e2731344ba331743_p122_mk169.png'
                : 'https://src.leju.com/imp/imp/deal/fe/68/e/f08246134bb6e9392f9cbdd0ab4_p122_mk169.png'
            "
          >
            <img class="big_show--logo" v-lazy="item.logo" />
            <div class="big_show--title">{{ item.brand }}</div>
            <template v-if="SHOW_TAO && item.taopass">
              <div class="big_show--new sprite-new-icon"></div>
            </template>
          </div>
          <Carousel
            v-if="item.extend_info.length"
            class="big_show--carousel"
            :class="`big_show--carousel__${item.extend_info.length}`"
            :disabled="item.extend_info.length < 3"
            :showPage="item.extend_info.length > 2"
            keyMap="hid"
            :data="item.extend_info"
            :options="{
              loop: true,
              centeredSlides: true,
              slidesPerView: 2.1,
              spaceBetween: 20,
              // lazy: true,
              loadPrevNext: true,
              loadPrevNextAmount: 2,
              on: {
                tap({ clickedSlide }) {
                  jump({
                    type: 'house',
                    data: item.extend_info[clickedSlide.children[0].dataset.i]
                  })
                }
              }
            }"
          >
            <template v-slot="{ item, i, length }">
              <div
                class="big_show--carousel_item"
                :class="
                  length === 1
                    ? 'house_info_item__fill'
                    : 'house_info_item__flex'
                "
                :data-i="i"
              >
                <div class="house_info_item--img">
                  <img
                    :src="
                      item.cover ||
                      'https://src.leju.com/imp/imp/deal/02/50/7/77710ffd520bbd3dad51dafe886_p122_mk169.jpg'
                    "
                    class="swiper-lazy house_info_item--image"
                  />
                  <div class="house_info_item--number" v-if="item.licence">{{
                    item.licence
                  }}</div>
                  <div
                    class="house_info_item--new_year sprite-new-year-straight"
                  ></div>
                </div>
                <div class="house_info_item--info">
                  <div class="house_info_item--name">{{ item.name }}</div>
                  <div
                    class="house_info_item--tags"
                    v-if="length === 1 && item.tags_name.length"
                  >
                    <div
                      class="house_info_item--tag"
                      v-for="t in item.tags_name"
                      :key="t"
                    >
                      {{ t }}
                    </div>
                  </div>
                  <div class="house_info_item--price">{{
                    item.price_display_info &&
                    item.price_display_info.price_display
                      ? item.price_display_info.price_display
                      : ' '
                  }}</div>
                </div>
              </div>
            </template>
          </Carousel>
        </div>
      </div>
    </div>
    <div class="worth_buy--wrapper" v-if="houseData.length">
      <Image
        class="u-title-img"
        lazy-load
        src="https://src.leju.com/imp/imp/deal/94/23/6/4a0069f8da44cb2b76f4623eb11_p122_mk169.png"
      />
      <List
        :key="city"
        v-if="houseState"
        class="worth_buy--list"
        :loading="houseState.loading"
        :finished="houseState.finished"
        finished-text="～ 已经到底了 ～"
        @load="houseState && houseState.load(houseData)"
      >
        <div
          class="worth_buy--item house_info_item__fill"
          v-for="item in houseData"
          :key="item.hid"
          @click="jump({ type: 'house', data: item })"
        >
          <div class="house_info_item--img">
            <img
              v-lazy="
                item.cover ||
                'https://src.leju.com/imp/imp/deal/02/50/7/77710ffd520bbd3dad51dafe886_p122_mk169.jpg'
              "
              class="house_info_item--image"
            />
            <div class="house_info_item--number" v-if="item.licence">{{
              item.licence
            }}</div>
            <div
              class="house_info_item--new_year sprite-new-year-straight"
            ></div>
          </div>
          <div class="house_info_item--info">
            <div class="house_info_item--city" v-if="item.unified_city_cn"
              >{{ item.unified_city_cn
              }}{{
                item.unified_district ? `/${item.unified_district}` : ''
              }}</div
            >
            <div class="house_info_item--name">{{ item.name }}</div>
            <div class="house_info_item--tags">
              <div
                class="house_info_item--tag"
                v-for="t in item.tags_name"
                :key="t"
              >
                {{ t }}
              </div>
            </div>
            <div class="house_info_item--price">{{
              item.price_display_info && item.price_display_info.price_display
                ? item.price_display_info.price_display
                : ' '
            }}</div>
          </div>
        </div>
      </List>
    </div>
    <div class="footer--wrapper">
      <div class="footer--name">北京怡生乐居信息服务有限公司</div>
      <div class="footer--phone">400-606-6969</div>
      <!-- <div class="footer--desc">其他信息展示：本活动最终解释权归公司所有</div> -->
    </div>
    <Popup
      v-model:show="showTaoPopup"
      round
      closeable
      teleport="body"
      v-if="SHOW_TAO"
    >
      <div class="popup-warp">
        <div class="p-cont-warp">
          <div class="popup-title">淘口令复制成功</div>
          <div class="popup-content">{{ taoling }}</div>
          <div class="popup-tips"
            ><span>使用说明：</span>复制淘口令打开手机淘宝即立享优惠！</div
          >
        </div>
      </div>
    </Popup>
    <div
      ref="copyElementRef"
      :data-clipboard-text="taoling"
      :style="{
        position: 'absolute',
        opacity: 0,
        height: 0,
        padding: 0,
        margin: 0,
        border: 'none'
      }"
    ></div>
    <SelectCity
      url="/?site=api&ctl=purchase&act=get_city"
      v-model:show="visibleCityPopup"
      v-model:currentCity="city"
    />
    <Popup
      :duration="0.7"
      :show="letterData.showPopup"
      class="letter--popup"
      teleport="body"
      :z-index="3000"
    >
      <div
        class="sprite-letter-close"
        @click=";(letterData.showPopup = false), (letterData.showFloat = true)"
      ></div>
      <img
        @click="letterData.openForm"
        class="letter--img"
        src="https://src.leju.com/imp/imp/deal/55/ec/9/896809f2d071f44ccc57e30c155_p122_mk169.png"
      />
    </Popup>
    <img
      @click="visibleFormPopup = true"
      :class="{ scrolling: letterData.scrolling, show: letterData.showFloat }"
      class="letter--float"
      src="https://src.leju.com/imp/imp/deal/25/cb/2/19b4ed2a8f356b9f88fb8015f4d_p122_mk169.png"
    />
    <DiglogForm v-model:show="visibleFormPopup" />
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  nextTick,
  onBeforeUpdate,
  onMounted,
  onUnmounted,
  reactive,
  Ref,
  ref,
  toRefs,
  watch
} from 'vue'
import { request } from '@/utils/request'
import { Toast, Image, List, Popup } from 'vant'
import Carousel from '@/components/Carousel.vue'
import SelectCity from '@/components/SelectCity.vue'
import DiglogForm from '@/components/DiglogForm.vue'
import Video from '@/components/Video.vue'
;(Image as any).props.showError.default = false
;(Image as any).props.showLoading.default = false
import { MainData, HouseData, LiveData } from '@/api-types.d.ts'
import ClipboardJS from 'clipboard'
import { useRoute } from 'vue-router'

export class Statistical {
  private isAppend = false
  perform() {
    if (!this.isAppend) {
      this.isAppend = true
      const s = document.createElement('script')
      s.src = '//cdn.leju.com/lejuTj/gather.source.js'
      s.onload = () => document.body.removeChild(s)
      document.body.append(s)
    }
  }
}

const statistical = new Statistical()

const hideVideoTips = (item: Record<string, any>) => {
  if (item.desc) {
    item.desc = ''
  }
}

const injectMapScript = (city: Ref<string>) => {
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.src =
    '//api.map.baidu.com/getscript?type=webgl&v=1.0&ak=XIZOl0V1kZbfpzkOu9XofR9rg3BMleqi'
  const res = new Promise<void>(r => {
    s.onload = () => {
      document.body.removeChild(s)
      r()
    }
  })
  document.body.append(s)
  setTimeout(() => {
    if (!window.BMapGL) {
      city.value = window.DEFAULT_CITY || ''
    }
  }, 2000)
  return res
}

let cityField: 'out_city_en' | 'city_en' = 'city_en'
const useLocation = () => {
  const route = useRoute()
  const city = ref((route.query.city as string) || '')
  const visibleCityPopup = ref(false)
  const getCurrent = () => {
    new window.BMapGL.LocalCity().get(({ name }: any) => {
      const ipCity = name === '全国' ? name : name.slice(0, -1)
      cityField = 'city_en'
      city.value = ipCity
      new window.BMapGL.Geolocation().getCurrentPosition((c: any) => {
        if (c) {
          const gpsCity = c.address.city.slice(0, -1)
          if (gpsCity !== ipCity) {
            cityField = 'city_en'
            city.value = gpsCity
          }
        }
      })
    })
  }
  if (city.value) {
    cityField = 'out_city_en'
  } else {
    injectMapScript(city).then(getCurrent)
  }

  return {
    city,
    visibleCityPopup,
    handleSelectCity() {
      cityField = 'out_city_en'
      visibleCityPopup.value = true
    }
  }
}

const getMainData = async (city: string) => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get<MainData.RootObject>(
      `/?site=api&ctl=purchase&act=get_config&${cityField}=${city}`
    )
    if (code == '0') {
      if (data.new_year_brand.length) {
        data.new_year_brand = data.new_year_brand.filter(
          ({ extend_info }) => extend_info && extend_info.length
        )
      }
      if (data.new_year_blessing.length) {
        data.new_year_blessing = data.new_year_blessing.filter(
          ({ video }) => !!video
        )
      }
      return data
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}
const getLiveData = async (city: string) => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get<LiveData.RootObject>(
      '/?site=api&ctl=purchase&act=get_video&out_city_en=' + city
    )
    if (code == '0') {
      return data.hongpan
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}
const useHouseData = (city?: string) => {
  const loading = ref(false)
  const finished = ref(true)
  let p = 1
  return {
    loading,
    finished,
    load: async (houseData: HouseData.Data[], reload = false) => {
      if (!city) return
      if (loading.value) return
      loading.value = true
      if (reload) p = 1
      try {
        const {
          data: {
            code,
            entry: { data, count }
          }
        } = await request.get<HouseData.RootObject>(
          '/?site=api&ctl=purchase&act=get_worth_buy&out_city_en=' +
            city +
            '&p=' +
            p++
        )
        finished.value = (p - 1) * 5 >= count
        loading.value = false
        if (code == 0) {
          if (reload) {
            houseData.splice(0, houseData.length, ...data)
          } else {
            houseData.push(...data)
          }
        } else {
          Toast.fail('获取数据失败')
        }
      } catch {
        loading.value = false
        Toast.fail('获取数据失败')
      }
    }
  }
}

const useLetterData = (visibleFormPopup: Ref<boolean>) => {
  const res = reactive({
    letterData: {
      showPopup: false,
      scrolling: false,
      showFloat: false,
      openForm() {
        visibleFormPopup.value = true
        res.letterData.showFloat = true
        res.letterData.showPopup = false
      }
    }
  })
  let timer = 0
  const onScroll = () => {
    if (!res.letterData.scrolling) {
      res.letterData.scrolling = true
    }
    clearTimeout(timer)
    timer = setTimeout(() => {
      res.letterData.scrolling = false
    }, 500)
  }
  onMounted(() => {
    window.addEventListener('scroll', onScroll)
  })
  onUnmounted(() => {
    clearTimeout(timer)
    window.removeEventListener('scroll', onScroll)
  })
  setTimeout(() => {
    res.letterData.showPopup = true
  }, 3000)
  return toRefs(res)
}

const getData = (city: Ref<string>) => {
  const res: {
    mainData: MainData.Data | Record<string, never>
    liveData: LiveData.Data['hongpan'] | Record<string, never>
    houseData: HouseData.Data[]
    houseState: ReturnType<typeof useHouseData> | null
  } = reactive({
    mainData: {},
    liveData: [],
    houseData: [],
    houseState: null
  })
  onMounted(() => {
    watch(
      city,
      async v => {
        if (v) {
          if (v === res.mainData?.city_map) return
          {
            const data = await getMainData(v)
            if (data) {
              res.mainData = data
              data.city_map && (v = city.value = data.city_map)
              data.city_pinyin && (window.city = data.city_pinyin)
              window.news_source = 'index'
              // statistical.perform()
              {
                const data = await getLiveData(v)
                if (data) {
                  res.liveData = data
                }
              }
              {
                res.houseState = useHouseData(v)
                res.houseState.load(res.houseData, true)
              }
            }
          }
        }
      },
      {
        immediate: true
      }
    )
  })
  return {
    ...toRefs(res)
  }
}

const useTaoling = () => {
  const showTaoPopup = ref(false)
  const copyElementRef = ref<HTMLDivElement | null>(null)
  const taoling = ref('')
  onMounted(() => {
    copyElementRef.value &&
      new ClipboardJS(copyElementRef.value).on('success', function (e) {
        e.clearSelection()
      })
  })
  const copyTaoling = (ling: string) => {
    taoling.value = ling
    nextTick(() => {
      copyElementRef.value?.click()
      showTaoPopup.value = true
    })
  }
  return {
    showTaoPopup,
    copyElementRef,
    taoling,
    copyTaoling
  }
}
const setBgc = () => {
  onMounted(() => {
    document.body.style.backgroundColor = '#d40218'
  })
  onUnmounted(() => {
    document.body.style.backgroundColor = 'inherit'
  })
}

export default defineComponent({
  name: 'Home',
  components: {
    Video,
    DiglogForm,
    Image,
    Carousel,
    List,
    Popup,
    SelectCity
  },
  setup() {
    const playerRefs = ref<any[]>([])
    onBeforeUpdate(() => {
      playerRefs.value = []
    })
    const { city, visibleCityPopup, handleSelectCity } = useLocation()
    setBgc()
    const visibleFormPopup = ref(false)
    return {
      playerRefs,
      city,
      visibleCityPopup,
      visibleFormPopup,
      handleSelectCity,
      SHOW_TAO: Number(useRoute().query.hide_tao) !== 1,
      ACTIVITY_ENTRY: window.ACTIVITY_ENTRY || '',
      jump(
        res:
          | { type: 'link'; data: string }
          | { type: 'tab'; data: 'home' | 'hot' }
          | { type: 'house'; data: HouseData.Data }
      ) {
        if (res.type === 'link') {
          window.location.href = res.data
        } else if (res.type === 'house') {
          window.location.href = `//m.leju.com/touch/house/${res.data.city_en}/${res.data.hid}?oc_source=m_zhuanti_fanxiang`
        } else if (res.type === 'tab') {
          if (res.data === 'home' && window.HOME_LINK) {
            window.location.href = window.HOME_LINK
          } else if (res.data === 'hot' && window.HOT_LINK) {
            window.location.href = window.HOT_LINK
          }
        }
      },
      hideVideoTips,
      ...getData(city as Ref<string>),
      ...useTaoling(),
      ...useLetterData(visibleFormPopup)
    }
  }
})
</script>

<style lang="scss">
img.van-image__img {
  display: block;
  width: 100%;
  height: 100%;
}
.letter--float {
  position: fixed;
  width: 149px;
  height: 126px;
  right: 0;
  bottom: 10vh;
  z-index: 100;
  transition: all 1s ease-in-out;
  transform: scale(0);
  &.show {
    transform: none;
  }
  &.scrolling {
    transform: translateX(150%) rotate(720deg) scale(0);
  }
}
.letter--popup {
  overflow: initial;
  background: none;
  // &.van-fade-enter-from,
  &.van-fade-leave-to {
    .letter--img {
      transform: translate(50%, 100%) scale(0);
    }
  }
  &.van-fade-leave-to {
    .sprite-letter-close {
      opacity: 0;
    }
  }
  .sprite-letter-close {
    position: absolute;
    top: -40px;
    right: -20px;
    transition: all 0.3s;
  }
  .letter--img {
    width: 270px;
    height: 236px;
    transition: all 0.7s ease-out;
  }
}
</style>
<style lang="scss" scoped>
.popup-warp {
  padding: 48px 16px 44px;
  .popup-closed {
    width: 16px;
    height: 16px;
  }
  .p-cont-warp {
    padding: 0 8px;
    .popup-title {
      padding-bottom: 24px;
      font-size: 24px;
      font-weight: 600;
      color: #484848;
      line-height: 34px;
    }
    .popup-content {
      padding: 20px 20px;
      width: 279px;
      line-height: 20px;
      background: #fafafa;
      word-break: break-all;
      border-radius: 8px;
      font-weight: 600;
      font-size: 14px;
      border: 2px dashed #d9001b;
    }
    .popup-tips {
      padding: 24px 20px 0;
      font-size: 14px;
      font-weight: 500;
      span {
        color: #d9001b;
      }
      line-height: 20px;
    }
  }
}
.u-text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home--wrapper {
  background: #d40218
    url(https://src.leju.com/imp/imp/deal/e0/65/1/56504d3cb1fee442df8dd25a579_cm375X1334_p122_mk169.png)
    top left / 100%;
}
.new--wrapper {
  position: relative;
  .logo_bg--img,
  .logo {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .logo_bg--img {
    width: 231px;
    height: 42px;
  }
  .logo {
    width: 180px;
    height: 21px;
  }
  .new_bg--img {
    width: 375px;
    height: 344px;
  }
  .cur-city--wrapper {
    position: absolute;
    top: 29px;
    left: 20px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000100;
    padding-top: 2px;
    padding-bottom: 3px;
    padding-right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    .cur-city--icon {
      margin-right: 3px;
      margin-top: -2px;
    }
    .cur-city--text {
      max-width: 4em;
      @extend .u-text-ellipsis;
    }
  }
  .tianmao {
    position: absolute;
    top: 181px;
    right: 10px;
  }
  .new--tabs {
    margin-top: 10px;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    .new--tab + .new--tab {
      margin-left: 8px;
    }
  }
}
.activity_entry--wrapper {
  height: 95px;
  border-radius: 4px;
  margin: 0 15px;
}
.cloud-bg {
  position: absolute;
  z-index: 0;
}
.u-title-img {
  margin-top: 30px;
}
.u-sub_title-img {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #feebb1;
  line-height: 20px;
  .sub_title {
    margin: 0 7px;
  }
}
.live--wrapper {
  position: relative;
  .live--content {
    margin: 15px 15px 0 15px;
    .live--carousel {
      .live_item {
        height: 194px - 6px;
        .live--cover {
          width: 100%;
          height: 100%;
        }
        .live--status {
          display: flex;
          align-items: center;
          position: absolute;
          left: 12px;
          bottom: 48px;
          height: 19px;
          padding: 0 6px 0 4px;
          border-radius: 4px;
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 19px;
          &.live--status__1 {
            background: linear-gradient(270deg, #f5448c 0%, #cf21e9 100%);
          }
          &.live--status__2 {
            background: linear-gradient(270deg, #f2b71b 0%, #ff7e33 100%);
          }
          &.live--status__3 {
            background: linear-gradient(270deg, #1e8ce2 0%, #2757fd 100%);
          }
          .live--icon {
            margin-right: 4px;
          }
        }
        .sprite-live {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .sprite-super-red {
          position: absolute;
          top: 10px;
          left: 10px;
        }
      }
    }
  }
}
.item--tips {
  @extend .u-text-ellipsis;
  padding: 0 10px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40px;
  background: rgba(0, 0, 0, 0.4);
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #feebb1;
  line-height: 40px;
}
.video--wrapper {
  position: relative;
  height: 195px;
  overflow: hidden;
  :deep .video--player {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.house_info_item__fill {
  position: relative;
  display: flex;
  .house_info_item--img {
    flex: 0 0 132px;
    position: relative;
    height: 99px;
    margin-right: 12px;
    border-radius: 4px;
    overflow: hidden;
    .house_info_item--image {
      width: 100%;
      height: 100%;
    }
    .house_info_item--number {
      @extend .u-text-ellipsis;
      position: absolute;
      max-width: 90%;
      top: 10px;
      left: 50%;
      transform: translateX(-50%);
      padding: 0 7px;
      height: 14px;
      line-height: 15px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 8px;
      opacity: 0.8;
      font-size: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .house_info_item--new_year {
      position: absolute;
      bottom: -1px;
      right: -1px;
    }
  }
  .house_info_item--info {
    flex: 0 0 175px;
    .house_info_item--city {
      @extend .u-text-ellipsis;
      width: 175px;
      height: 15px;
      font-size: 11px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fbbd79;
      line-height: 15px;
      margin-bottom: 5px;
    }
    .house_info_item--name {
      @extend .u-text-ellipsis;
      width: 175px;
      height: 23px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #feebb1;
      line-height: 23px;
      margin-bottom: 8px;
    }
    .house_info_item--tags {
      width: 175px;
      margin-bottom: 8px;
      display: flex;
      color: #f9c37d;
      .house_info_item--tag {
        @extend .u-text-ellipsis;
        text-align: center;
        padding: 0 5px;
        width: 54px;
        height: 20px;
        background: #f9c37d;
        border-radius: 4px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #dc2f37;
        + .house_info_item--tag {
          margin-left: 4px;
        }
        &:first-child {
          color: #d30019;
        }
      }
    }
    .house_info_item--price {
      @extend .u-text-ellipsis;
      width: 175px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #feebb1;
      line-height: 20px;
    }
  }
}
.house_info_item__flex {
  position: relative;
  .house_info_item--img {
    position: relative;
    text-align: center;
    .house_info_item--image {
      width: 100%;
      height: 100%;
    }
    .house_info_item--number {
      @extend .u-text-ellipsis;
      position: absolute;
      max-width: 80%;
      top: 11px;
      left: 11px;
      padding: 0 7px;
      height: 12px;
      line-height: 13px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 8px;
      opacity: 0.8;
      font-size: 8px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .house_info_item--tips {
      @extend .u-text-ellipsis;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 24px;
      background: linear-gradient(180deg, #3f87af 0%, #265c98 100%);
      padding-left: 9px;
      padding-right: 48px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;
    }
    .house_info_item--new_year {
      position: absolute;
      bottom: -1px;
      right: -1px;
    }
  }
  .house_info_item--info {
    padding: 8px 12px 12px;
    background: linear-gradient(180deg, #ff4040 0%, #dc2f37 100%);
    .house_info_item--city {
      display: none;
    }
    .house_info_item--name {
      @extend .u-text-ellipsis;
      height: 23px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #feebb1;
      line-height: 23px;
    }
    .house_info_item--tags {
      display: none;
    }
    .house_info_item--price {
      @extend .u-text-ellipsis;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #feebb1;
      line-height: 17px;
    }
  }
}
.new_year_quotation--wrapper {
  .new_year_quotation--content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    padding: 0 10px;
    .new_year_quotation--item {
      margin-top: 15px;
      &.house_info_item__fill {
        flex: 0 0 100%;
        padding: 47px 17px 17px;
        height: 163px;
        background-position: top left;
        background-size: cover;
        .new_year_quotation--niu {
          position: absolute;
          top: -4px;
          right: 24px;
        }
      }
      &.house_info_item__flex {
        padding: 36px 16px 0;
        height: 211px;
        flex: 0 0 173px;
        background-repeat: no-repeat;
        background-position: top left;
        background-size: 100% 100%;
        .house_info_item--img {
          height: 115px;
          border-radius: 4px;
          overflow: hidden;
        }
        .house_info_item--info {
          max-width: 140px;
          background: none;
          padding: 8px 0 0;
        }
        .new_year_quotation--niu {
          position: absolute;
          top: -5px;
          right: 23px;
        }
      }
      .house_info_item--number {
        top: 8px;
      }
    }
  }
}
.send_bless--wrapper {
  .send_bless--carousel_wrapper {
    position: relative;
    .send_bless--carousel {
      margin: 12px 15px 0;
      :deep .swiper-container {
        border: none;
        border-radius: 15px;
      }
      :deep .video--player {
        padding: 12px;
        box-sizing: border-box;
      }
      .video--tips {
        left: 13px;
        right: 13px;
        height: 27px;
        line-height: 25px;
        bottom: 13px;
      }
    }
    .send_bless--border {
      position: absolute;
      top: 0;
      left: 15px;
      width: 345px;
      height: 195px;
      z-index: 10;
      pointer-events: none;
    }
  }
}
.early_see--wrapper {
  .video--wrapper {
    position: relative;
    margin: 12px 15px 0;
    border: 3px solid #efb258;
    border-radius: 10px;
    .video--tips {
      border-radius: 0 0 7px 7px;
    }
    :deep .vcp-player {
      border-radius: 7px;
    }
  }
}
.ad_placeholder--list {
  position: relative;
  margin: 30px 15px 0;
  :deep .swiper-wrapper {
    height: 138px;
  }
  .ad_placeholder--item {
    width: 100%;
    height: 100%;
  }
}
.big_show--wrapper {
  .big_show--list {
    padding-top: 5px;
    .big_show--item {
      margin-top: 10px;
      padding: 28px 0 22px;
      border-top: 3px solid #efb258;
      border-bottom: 3px solid #efb258;
      background-color: #d40218;
      background-size: 375px auto;
      background-repeat: no-repeat;
      background-position: 0 0;
      .big_show--title-wrapper {
        position: relative;
        margin: 0 13px;
        height: 65px;
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 254px auto;
        background-size: 345px auto;
        .big_show--logo {
          position: absolute;
          left: 3px;
          top: 3px;
          border: 3px solid #efb258;
          background: #fff;
          width: 61px;
          height: 61px;
          border-radius: 50%;
        }
        .big_show--title {
          @extend .u-text-ellipsis;
          position: absolute;
          padding-left: 12px;
          top: 2px;
          left: 66px;
          right: 100px;
          height: 27px;
          font-size: 19px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #feebb1;
          line-height: 27px;
        }
        .big_show--new {
          position: absolute;
          top: -5px;
          left: 308 - 13px;
        }
      }
      .big_show--carousel {
        margin-top: 20px;
        &.big_show--carousel__2 {
          :deep .swiper-wrapper {
            display: flex;
            padding: 0 10px;
            box-sizing: border-box;
            .swiper-slide {
              margin: 0 5px;
              flex: 0.5;
              max-width: calc(50% - 10px);
            }
          }
        }
        :deep .swiper-container {
          border: none;
          border-radius: 0;
        }
        .big_show--carousel_item {
          border: 3px solid #efb258;
          border-radius: 10px;
          overflow: hidden;
          &.house_info_item__fill {
            margin: 0 15px;
            padding: 9px;
            background: linear-gradient(180deg, #ff4040 0%, #dc2f37 100%);
            .house_info_item--img {
              border-radius: 4px;
              overflow: hidden;
            }
          }
          &.house_info_item__flex {
            .house_info_item--img {
              height: 123px;
            }
          }
        }
      }
    }
  }
}
.worth_buy--wrapper {
  .worth_buy--list {
    padding: 10px 15px;
    :deep .van-loading__text,
    :deep .van-list__finished-text {
      margin-top: 20px;
      line-height: 1;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #feebb1;
    }
    .worth_buy--item {
      margin-top: 10px;
      padding: 9px;
      border: 3px solid #efb258;
      border-radius: 10px;
      background: linear-gradient(180deg, #ff4040 0%, #dc2f37 100%);
      .house_info_item--img {
        border-radius: 4px;
        overflow: hidden;
      }
    }
  }
}
.footer--wrapper {
  padding-top: 20px;
  padding-bottom: 35px;
  text-align: center;
  color: #fbbd79;
  .footer--name {
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 17px;
    margin-bottom: 3px;
  }
  .footer--phone {
    height: 14px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 14px;
  }
  .footer--desc {
    height: 14px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 14px;
  }
}
</style>
